import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

// Create an instance of the React plugin
const reactPlugin = new ReactPlugin();

// Initialize Application Insights with config
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_CONNECTION_STRING, // to connect app with application insights
    extensions: [reactPlugin], // to track React-specific events
    enableAutoRouteTracking: true, // Automatically track route changes in SPAs
    autoTrackPageVisitTime: true, // Automatically track how long users stay on each page
    // disableAjaxTracking: false, // to track AJAX calls
    // enableCorsCorrelation: true, // Correlate telemetry across domains using CORS
    // enableRequestHeaderTracking: true, // Track request headers for AJAX calls
    // enableResponseHeaderTracking: true, // Track response headers for AJAX calls
  },
});

// Load and activate Application Insights with the above config
appInsights.loadAppInsights();

// Telemetry initializer with custom tags to filter easily in azure portal
appInsights.addTelemetryInitializer((env) => {
  env.tags = env.tags || {};
  env.tags["ai.cloud.role"] = "UF Advisor frontend";
});

export { reactPlugin, appInsights };
